import { useState, useEffect, useRef, Fragment, memo, useMemo } from "react";
import style from "./../index.module.scss";
import styleUi from "./Setting.module.scss";
import Cookies from 'universal-cookie';
import { CSSTransition } from 'react-transition-group';
import * as YStyled from "../../Styleds";
import AppConfig from '../../AppConfig';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import apiManager from './../../ApiManager';
const cookies = new Cookies(null, { path: '/' });
const Setting = ({ setModalType, arg, addModalType, set_screenId }) => {
    const [inProp, setInProp] = useState(false);
    const [cmds, set_cmds] = useState([
        [{
            name: "個人檔案", disable:false,hasArrow: true, fn: () => {
                addModalType({ cls: "SettingProfile" })
            }
        }, {
            name: "權限設定", disable:false, hasArrow: true, fn: () => {
                addModalType({ cls: "SettingPermissions" })
            }
        }],
        [{
            name: "發送好友邀請連結", disable:false, hasArrow: true, fn: () => {
                addModalType({ cls: "SendFriendInvite" })
            }
        }],
        [{
            name: "聯絡我們", disable:false, hasArrow: true, fn: () => {
                addModalType({ cls: "Contact" })
            }
        }, {
            name: "使用條款", disable:false, hasArrow: true, fn: () => {
                addModalType({ cls: "Terms" })
            }
        }],
        [{
            name: "登出", disable:false, hasArrow: false, fn: () => {
                /* cookies.remove('loginToken');
               setInProp(false);
               set_screenId({ind:0}) */
                fetch(`${AppConfig.baseUrl()}/self-service/logout/browser?return_to`, {
                    method: 'GET',
                    credentials: 'include',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                    })
                })
                    .then((response) => {
                        if (response.status === 200) {
                            return response.json();
                        }
                        else if (response.status === 204) {
                            return [];
                        }
                        else {
                            console.error(response);
                        }
                    })
                    .then((data) => {
                        console.log("data", data)
                        window.location.href = data.logout_url;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });

            }
        }],
    ]);
    useEffect(() => {
        setInProp(true);
        document.title = "設定";
    }, [])
    function CmdDiv_1({ cmd, index }) { // 接收一个 index 作为 key 的基础
        return (
            <YStyled.Row key={index}>
                <YStyled.Label style={{ width: "100%", marginTop: "1rem", paddingRight: "0px" }}>
                    <YStyled.Col>
                        {cmd.map((v, _k) => {
                            return (
                                <Fragment key={_k}> {/* 为每个 Fragment 添加 key */}
                                    <YStyled.Row style={{ paddingRight: "1rem" }} onClick={e => {
                                        if (v.fn&&v.disable===false)
                                            v.fn();
                                    }}>
                                        <YStyled.Span fontWeight={400} size={17}>{v.name}</YStyled.Span>
                                        {v.hasArrow &&
                                            <ArrowForwardIosIcon style={{ fontSize: "1rem", color: "#3C3C4355" }} />
                                        }
                                    </YStyled.Row>
                                    {
                                        (_k + 1) < cmd.length &&
                                        <YStyled.Hr style={{ margin: ".8rem 0" }} />
                                    }
                                </Fragment>
                            );
                        })}
                    </YStyled.Col>
                </YStyled.Label>
            </YStyled.Row>
        );
    }

    return (
        <div className={style.modal}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.SwipePageEnterActive,
                enterDone: style.SwipePageEnterDone,
                exitActive: style.SwipePageExit,
                exitDone: style.SwipePageExitActive
            }}
                onExited={async () => {
                    await new Promise(resolve => requestAnimationFrame(resolve));
                    setModalType(prev => prev.filter(v => v.cls !== "Setting"))
                }}
            >
                <div className={`${style.SwipePage} ${style.Page}`} >
                    <div className={styleUi.app}>
                        <div className={styleUi.headerBar}>
                            <img src="./assets/ui/back.png" onClick={e => { setInProp(false) }} />
                            <YStyled.Span fontWeight={500} size={22}>設定</YStyled.Span>
                        </div>
                        <div className={styleUi.view}>
                            {cmds.map((cmd, k) => {
                                return <CmdDiv_1 cmd={cmd} key={k} index={k} />;
                            })}
                        </div>
                    </div>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(Setting);